const en = {
  tryAdjusting: 'Try adjusting your search or filters',
};

const de = {
  tryAdjusting: 'Passen Sie Ihre Suche oder Filter an',
};

const emptyState = { en, de };
export default emptyState;
